/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_Help_Center_AdminInputs */

const en_page_title_help_center_admin = /** @type {(inputs: Page_Title_Help_Center_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support admin`)
};

const nl_page_title_help_center_admin = /** @type {(inputs: Page_Title_Help_Center_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supportbeheer`)
};

/**
* | output |
* | --- |
* | "Support admin" |
*
* @param {Page_Title_Help_Center_AdminInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const page_title_help_center_admin = /** @type {((inputs?: Page_Title_Help_Center_AdminInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_Help_Center_AdminInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_page_title_help_center_admin(inputs)
	return en_page_title_help_center_admin(inputs)
});